import {useIntl} from 'react-intl';
import EtatBadge from '../EtatBadge';
import {DisplaySite} from '../../Helpers/ServiceHelper';
import {getStatusColor, getStatusLabel} from '../../Helpers/stateHelper';
import {ListService} from '../../Types/service';

interface TelephonyServiceHeaderProps {
  service: ListService;
  onBack: () => void;
  details?: string;
}

/**
 * En-tête d'une prestation de téléphonie, calqué sur celui du détail d'un lien
 * (LienDetailPage) : bouton retour, nom, identifiant, BU et site, état.
 * `details` ajoute une ligne de contexte (ex. le compte ou la destination consultés).
 */
const TelephonyServiceHeader = ({
  service,
  onBack,
  details,
}: TelephonyServiceHeaderProps): JSX.Element => {
  const intl = useIntl();

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-outline btn-outline-primary btn-active-light-primary d-inline-flex align-items-center mb-5"
        onClick={onBack}
      >
        <i className="bi bi-arrow-left me-2" />
        {intl.formatMessage({id: 'COMMON.BACK'})}
      </button>

      <div className="card mb-5">
        <div className="card-body d-flex flex-wrap align-items-start justify-content-between gap-4">
          <div className="d-flex align-items-start">
            <div className="symbol symbol-50px me-4">
              <span className="symbol-label bg-light-primary">
                <i className="bi bi-telephone fs-2 text-primary" />
              </span>
            </div>
            <div>
              <h2 className="fs-2 fw-bold text-gray-900 mb-1">
                {service.serviceName || service.link_name}
              </h2>
              <div className="text-muted fs-6 mb-3">
                {intl.formatMessage(
                  {id: 'TELEPHONIE.DETAILS.SERVICE_ID_INFO'},
                  {
                    serviceId: service.serviceId,
                    buName: service.buName,
                    site: DisplaySite(service),
                  }
                )}
              </div>
              {details && <div className="fs-6 fw-semibold text-gray-800 mb-3">{details}</div>}
              {service.state && (
                <div className="d-flex flex-wrap gap-2">
                  <EtatBadge
                    color={getStatusColor(service.state)}
                    label={getStatusLabel(service.state, intl) || '-'}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TelephonyServiceHeader;
